import(/* webpackMode: "eager" */ "/app/apps/portal/src/app/global-error.tsx");
